import { centsToEuros } from '@/constants'
import ctl from '@netlify/classnames-template-literals'
import { useTranslation } from 'react-i18next'
import { CampaignInvoiceModel } from 'src/ui/views'

const statusKeyMap: Record<string, string> = {
	overdue: 'overview.invoiceStatus.overdue',
	'partially paid': 'overview.invoiceStatus.partiallyPaid',
	open: 'overview.invoiceStatus.open',
	paid: 'overview.invoiceStatus.paid',
	void: 'overview.invoiceStatus.void',
	uncollectible: 'overview.invoiceStatus.uncollectible',
}

export function CampaignInvoiceStatusBadge({ invoice }: { invoice: CampaignInvoiceModel }) {
	const { t } = useTranslation('common')

	let bgColour = 'bg-purple-500'
	let status = invoice.status

	let remaining = invoice.amountDue - invoice.amountPaid

	if (invoice.isOverdue && invoice.status === 'open') {
		status = 'overdue'
		bgColour = 'bg-red-500'
	} else if (invoice.status === 'open') {
		bgColour = 'bg-yellow-500'

		if (remaining > 0 && remaining < invoice.total) {
			status = 'partially paid'
		}
	} else if (invoice.status === 'paid') {
		bgColour = 'bg-green-500'
	} else if (invoice.status === 'void' || invoice.status === 'uncollectible') {
		bgColour = 'bg-black'
	}

	const translatedStatus = statusKeyMap[status] ? t(statusKeyMap[status]) : status

	return (
		<div
			className={ctl(
				`${bgColour} text-white inline-block px-2.5 py-2.5 uppercase tracking-tightest text-xs [text-box:trim-both_cap_alphabetic]`,
			)}
			title={remaining > 0
				? t('overview.invoiceStatus.remainingAmount', { amount: centsToEuros(remaining) })
				: ''}
		>
			{translatedStatus}
		</div>
	)
}
